import { render, staticRenderFns } from "./WorkFlowsLayout.vue?vue&type=template&id=0f4ac111&scoped=true"
import script from "./WorkFlowsLayout.vue?vue&type=script&lang=js"
export * from "./WorkFlowsLayout.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowsLayout.vue?vue&type=style&index=0&id=0f4ac111&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ac111",
  null
  
)

export default component.exports